import type { FC } from 'react';
import React, { useState, useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Flex, Stack, xcss } from '@atlaskit/primitives';

import type { Ari } from '@atlassian/ari';

import { ConfluenceManualRulesContainer } from '../common/ConfluenceManualRulesContainer';
import { AutomationModalBody } from '../automation-modal/AutomationModalBody';
import { AutomationModalFooter } from '../automation-modal/AutomationModalFooter';

import { AutomationRovoButtonHeader } from './AutomationRovoButtonHeader';

const BodyStyles = xcss({
	maxHeight: '600px',
	overflowY: 'auto',
	overflowX: 'hidden',
});

type AutomationComponentProps = {
	aris: Ari[];
	analyticsSource: string;
	spaceKey: string;
	title: string;
	contentTitle: string;
};

const ContainerStyles = xcss({
	height: '100%',
	paddingBottom: 'space.200',
	paddingInline: 'space.100',
});

export const AutomationRovoButton: FC<AutomationComponentProps> = ({
	aris,
	analyticsSource,
	spaceKey,
	title,
	contentTitle,
}) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const [selectedRuleId, setSelectedRuleId] = useState<number | undefined>();

	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendScreenEvent',
			data: {
				name: analyticsSource,
			},
		}).fire();
	}, [createAnalyticsEvent, analyticsSource]);

	return (
		<ConfluenceManualRulesContainer
			aris={aris}
			analyticsSource={analyticsSource}
			spaceKey={spaceKey}
			singleSpace
		>
			{() => {
				return (
					<Stack spread="space-between" xcss={ContainerStyles}>
						<Stack space="space.200">
							<AutomationRovoButtonHeader title={title} contentTitle={contentTitle} />
							<Box xcss={BodyStyles}>
								<AutomationModalBody
									selectedRuleId={selectedRuleId}
									setSelectedRuleId={setSelectedRuleId}
								/>
							</Box>
						</Stack>
						<Flex justifyContent="end">
							<AutomationModalFooter
								selectedRuleId={selectedRuleId}
								onClose={() => {}}
								inRovoButton
							/>
						</Flex>
					</Stack>
				);
			}}
		</ConfluenceManualRulesContainer>
	);
};
